import { CheckCircle2, OctagonAlert, Star, TriangleAlert, Minus } from "lucide-react";
import { KPI_TONE_CLASSES, type KpiTone } from "./kpiTypes";

const ICON_BY_TONE: Record<KpiTone, typeof CheckCircle2> = {
  amber: TriangleAlert,
  green: CheckCircle2,
  gold: Star,
  red: OctagonAlert,
  grey: Minus,
};

export function KpiStatusBadge(props: { tone: KpiTone; label: string; compact?: boolean }) {
  const { tone, label, compact = false } = props;
  const cls = KPI_TONE_CLASSES[tone];
  const Icon = ICON_BY_TONE[tone];
  const sizing = compact ? "h-3.5 w-3.5" : "h-4 w-4";
  const padding = compact ? "px-1.5 py-0.5 text-[11px]" : "px-2 py-0.5 text-xs";
  return (
    <span
      className={[
        "inline-flex items-center gap-1 rounded-full ring-1",
        padding,
        cls.fill,
        cls.ring,
        cls.text,
        "font-medium",
      ].join(" ")}
      role="status"
    >
      <Icon className={sizing} aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
